'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowUpRightFromSquare, iconArrowUpRightFromSquareTag } from '@ni/nimble-components/dist/esm/icons/arrow-up-right-from-square';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowUpRightFromSquare };
export { iconArrowUpRightFromSquareTag };
export const NimbleIconArrowUpRightFromSquare = wrap(IconArrowUpRightFromSquare);